import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import { JuicioDiagnostico } from '../models/';

@Injectable()
export class JuicioDiagnosticoService extends RESTService<any> {

  public juicioDiagnostico: JuicioDiagnostico;
  public juiciosDiagnosticocios: JuicioDiagnostico[];

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  /**
   * getExploracio: obtiene el listado completo de JuicioDiagnostico de un paciente
   * @param pacienteId: string
   * @return any
   */
  obtenerJuicioDiagnostico(pacienteId: string, visita: string): any {
    return this._http.post(environment.api_host + 'juicioDiagnosticoConsulta/obtenerJuicioDiagnosticoConsulta', {
      numeroExpediente: pacienteId,
      visita: visita,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /*** guardarJuicioDiagnostico* @param params: object* @return boolean*/
  guardarJuicioDiagnostico(params: any): Observable<string> {
    return this._http.post(environment.api_host + 'diagnosticos/nuevoDiagnosticoPaciente', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.respuesta.resultado === 'OK') {
        return true;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }

  borrarDiagnostico(params: any): Observable<boolean> {
    return this._http.post(environment.api_host + 'juicioDiagnosticoConsulta/borrarJuicioDiagnostico', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.respuesta.resultado === 'OK') {
        return true;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }

}



// WEBPACK FOOTER //
// ./src/services/juiciodiagnostico.service.ts